module.exports = __webpack_public_path__ + "img/Comm Uprate Icons.7ed79689.png";